module.exports = __webpack_public_path__ + "static/media/square.4839b817.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/square.png
// module id = 51
// module chunks = 0 1